module.exports = __webpack_public_path__ + "img/home-largest-badge.c863badb.png";